import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, Table } from "reactstrap";
import { Card, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";
import {
  postMethod
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddStocktransfer = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const isView = queryParams.get("view") === "true";
  const jwl_branch_id = localStorage.getItem("jwl_branch_id");
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [productsValidation, setProductsValidation] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [stocktransferproducts, setstocktransferproducts] = useState([]);
  const [seachProdutList, setseachProdutList] = useState([]);
  const [seachProdutListLoading, setseachProdutListLoading] = useState(false);
  const [stockinproductParam, setStockinproductParam] = useState({
    product_id: "",
    product: "",
    product_code: "",
    qty: "",
    url_image: "",
    image_path: "",
    transfer_qty: "",
    status: "Pending",
    isImageUrl: "",
  });

  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id,
    to_branch_id: 0,
    date: "",
    entry_no: "",
    remarks: "",
    status: "",
    stock_in_products: [],
  });
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  useEffect(() => {
    setLoad(true);
    if (id !== null) {
      var temp = window.atob(id);
      postMethod("api/transactions/stockTransfer/preview", { tran_id: temp }).then((dataD) => {
        var data = dataD.data;
        setParam({
          ...param,
          date: (data[0].date ? data[0].date.split("T")[0] : ""),
          entry_no: data[0].entry_no,
          to_branch_id: data[0].to_branch_id,
          remarks: data[0].remarks,
          status: data[0].status
        });
        setstocktransferproducts(data[1]);
        setLoad(false);
      });
    }
    else {
      postMethod("api/transactions/stockTransfer/preview", { tran_id: 0 }).then((dataD) => {
        var data = dataD.data;
        setParam({
          ...param,
          date: data[0].date,
          entry_no: data[0].entry_no,
          status: data[0].status
        });
        setLoad(false);
      });
    }
    postMethod("api/transactions/stockin/getproductlist", {}).then((data) => {
      // alert(JSON.stringify(data.data))
      setProductlist(data.data);
    });

    postMethod("api/transactions/stockin/getbranchlist", {}).then((data) => {
      setBranchlist(data.data);
    });
  }, []);

  // Search Products 

  // const searchProductFun = ()=>{
  //   setseachProdutListLoading(true);
  //   postMethod("api/transactions/stockTransfer/getProducts", { search:searchProduct}).then((data) => {
  //     setseachProdutList(data.data);
  //      setseachProdutListLoading(false);
  //   });
  // }
  const searchProductFun = () => {
    setseachProdutListLoading(true);

    postMethod("api/transactions/stockTransfer/getProducts", {
      search: searchProduct
    }).then((data) => {

      if (!data.data || data.data.length === 0) {
        showErrorToast("Product does not exist");
        setseachProdutList([]);
      } else {

        const temp = data.data.map(item => ({
          ...item,
          transfer_qty: 1      // <-- every new search starts from 1
        }));

        setseachProdutList(temp);
      }

      setseachProdutListLoading(false);
    });
  }
  // check object is null or undefined
  const checkObject = (obj) => {
    return obj === undefined ? {} : Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  //Add product into Array
  const AddProduct = () => {

    if (stocktransferproducts.findIndex(x => x.product_id == stockinproductParam.product_id) == -1) {
      if (stockinproductParam.qty !== "") {
        // stocktransferproducts.push(stockinproductParam);
        stocktransferproducts.push({
          ...stockinproductParam,
          isImageUrl: stockinproductParam.isImageUrl
        });

        setstocktransferproducts(stocktransferproducts);
        setStockinproductParam({
          product_id: "",
          product_code: "",
          product: "",
          size_length: "",
          color: "",
          qty: "",
          url_image: "",
          image_path: "",
          transfer_qty: "",
          status: "Pending",
          isImageUrl: "",
        });
      }
    }
  };

  const AddProductSearch = (objD) => {
    if (stocktransferproducts.findIndex(x => x.product_id == objD.product_id) == -1) {
      if (objD.qty !== "") {
        stocktransferproducts.push({ product_id: objD.product_id, product_code: objD.product_code, product: objD.product, size_length: objD.size_length, color: objD.color, qty: objD.qty, transfer_qty: objD.transfer_qty, image_path: objD.image_path, url_image: objD.url_image, isImageUrl: objD.isImageUrl });
        let tempArry = [...stocktransferproducts];
        setstocktransferproducts(tempArry);
      }
    }
  };
  const removeProduct = (i) => {
    let tempArry = [...stocktransferproducts];
    tempArry.splice(i, 1);
    setstocktransferproducts(tempArry);
  };

  //Insert Data
  const _Save = () => {

    var qty_validation = false;
    stocktransferproducts.forEach(element => {
      const qty = Number(element.qty) || 0;
      const transferQty = Number(element.transfer_qty) || 1;

      // console.log("Compare ::", qty, transferQty);
      // console.log("TESTING ::",JSON.stringify(stocktransferproducts));
      if (qty < transferQty) {
        qty_validation = true;
        console.log("break");
      }
    });
    if (stocktransferproducts.length == 0) {
      setProductsValidation(true);
    }
    else if (qty_validation) {
      showErrorToast("Qty is not more then available qty.")
    }
    else {
      setLoadInsert(true);

      var temp = id == null ? "0" : window.atob(id);
      let temparam = {
        tran_id: temp,
        from_branch_id: param.from_branch_id,
        to_branch_id: param.to_branch_id,
        date: param.date,
        entry_no: param.entry_no,
        remarks: param.remarks,
        stock_transfer_products: stocktransferproducts
      };

      postMethod("api/transactions/stockTransfer/insert_1", temparam).then((data) => {

        if (data.data[0].valid) {
          setSuccess(true);
          setTimeout(() => {
            props.history.push("/branch/stock-transfer");
          }, 2000);
        }
        else {
          setLoadInsert(false);
        }
      });
    }
  };

  const handleDelete = () => {
    var proceed = window.confirm("Do you Really Wish to Delete this Entry..?!");
    var temp = window.atob(id);
    if (proceed) {
      setLoadDelete(true);
      postMethod("api/transactions/stockTransfer/delete", { tran_id: temp }).then((data) => {
        if (data.data[0].valid) {
          setSuccessDelete(true);
          setTimeout(() => {
            props.history.push("/branch/stock-transfer");
          }, 2000);
        }
        else {
          setSuccessDelete(true);
          setTimeout(() => {
            setSuccessDelete(false);
          }, 4000);
          setLoadDeleteMsg(data.error)
          setLoadDelete(false);
        }
      });
    }
  };

  const getImage = (item) => {
    if (!item) return "";
    let path = item.image_path || "";
    let baseUrl = item.url_image || "https://admin.quicktagg.com/";

    if (item.isImageUrl === true || item.isImageUrl === "true") {
      if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
        return path;
      }
      return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
    }

    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
      return path;
    }

    return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
  };

  const loadImageAsBase64 = async (src) => {
    if (!src) return null;
    try {
      const res = await fetch(src);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    return new Promise((resolve) => {
      const corsSrc = src.includes("data:") ? src : src + (src.includes("?") ? "&" : "?") + "cb=" + Date.now();
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 60;
          canvas.height = img.naturalHeight || img.height || 60;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
          resolve(dataUrl);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = corsSrc;
    });
  };

  const exportToExcel = () => {
    try {
      const selectedBranch = branchlist.find((b) => String(b.branch_id) === String(param.to_branch_id))?.company_name || "-";
      const formattedDate = param.date ? moment(param.date).format("DD-MM-YYYY") : "-";

      const sheetData = [
        ["Entry No.", param.entry_no || "-"],
        ["Date", formattedDate],
        ["To Branch", selectedBranch],
        ["Status", param.status || "-"],
        ["Remarks", param.remarks || "-"],
        [],
        [`Transfer Products (${stocktransferproducts.length} Items)`],
        ["Product Code", "Name", "Gender", "Color", "Size", "Price", "Available Qty", "Transfer Qty", "Status"],
        ...stocktransferproducts.map((item) => [
          item.product_code || "",
          item.product_name || "",
          item.gender || "",
          item.color || "",
          item.size_length || "",
          item.price ? `₹ ${item.price}` : "",
          item.qty ?? "",
          item.transfer_qty ?? "",
          item.status || "-",
        ]),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock_Transfer");
      const filename = `Stock_Transfer_${param.entry_no || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.xlsx`;
      XLSX.writeFile(workbook, filename);
      showSuccessToast("Excel downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating Excel file.");
    }
  };

  const exportToPDF = async () => {
    try {
      setLoad(true);
      const pdf = new jsPDF("p", "mm", "a4");
      let y = 15;

      const selectedBranch = branchlist.find((b) => String(b.branch_id) === String(param.to_branch_id))?.company_name || "-";
      const formattedDate = param.date ? moment(param.date).format("DD-MM-YYYY") : "-";

      pdf.setFontSize(10);
      pdf.setFont(undefined, "normal");
      pdf.text(`Entry No.: ${param.entry_no || "-"}`, 14, y);
      pdf.text(`Date: ${formattedDate}`, 85, y);
      y += 6;
      pdf.text(`To Branch: ${selectedBranch}`, 14, y);
      pdf.text(`Status: ${param.status || "-"}`, 85, y);
      y += 6;
      pdf.text(`Remarks: ${param.remarks || "-"}`, 14, y);
      y += 8;

      pdf.setFont(undefined, "bold");
      pdf.text(`Transfer Products (${stocktransferproducts.length} Items)`, 14, y);
      y += 6;

      // Table Headers
      pdf.setFontSize(8);
      pdf.setFont(undefined, "bold");
      pdf.setFillColor(240, 243, 246);
      pdf.rect(14, y - 4, 181, 6, "F");

      const colPositions = [15, 45, 75, 95, 110, 125, 142, 160, 180];
      const headers = ["Product Code", "Name", "Gender", "Color", "Size", "Price", "Available", "Transfer Qty", "Image"];
      headers.forEach((h, idx) => {
        pdf.text(h, colPositions[idx], y);
      });

      y += 4;
      pdf.line(14, y - 1, 195, y - 1);
      y += 4;

      // Pre-load images
      const loadedImages = await Promise.all(
        stocktransferproducts.map((item) => loadImageAsBase64(getImage(item)))
      );

      pdf.setFont(undefined, "normal");
      for (let index = 0; index < stocktransferproducts.length; index++) {
        const item = stocktransferproducts[index];
        const imgData = loadedImages[index];
        const rowHeight = imgData ? 13 : 7;

        if (y + rowHeight > 275) {
          pdf.addPage();
          y = 15;
        }

        const textY = imgData ? y + 5 : y;
        pdf.text(String(item.product_code || "-"), colPositions[0], textY, { maxWidth: 28 });
        pdf.text(String(item.product_name || "-"), colPositions[1], textY, { maxWidth: 28 });
        pdf.text(String(item.gender || "-"), colPositions[2], textY, { maxWidth: 18 });
        pdf.text(String(item.color || "-"), colPositions[3], textY, { maxWidth: 13 });
        pdf.text(String(item.size_length || "-"), colPositions[4], textY, { maxWidth: 13 });
        pdf.text(item.price ? `₹ ${item.price}` : "-", colPositions[5], textY, { maxWidth: 15 });
        pdf.text(String(item.qty ?? "-"), colPositions[6], textY, { maxWidth: 15 });
        pdf.text(String(item.transfer_qty ?? "-"), colPositions[7], textY, { maxWidth: 18 });

        if (imgData) {
          try {
            pdf.addImage(imgData, "JPEG", colPositions[8], y, 10, 10);
          } catch (e) {
            pdf.text("-", colPositions[8], textY);
          }
        } else {
          pdf.text("-", colPositions[8], textY);
        }

        y += rowHeight + 2;
      }

      const filename = `Stock_Transfer_${param.entry_no || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.pdf`;
      pdf.save(filename);
      showSuccessToast("PDF downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating PDF file.");
    } finally {
      setLoad(false);
    }
  };

  return (
    <>
      {load ? <Loader /> : null}
      <Form className="stock-transfer-editor-form" onSubmit={handleSubmit(_Save)}>
        <input
          type="hidden"
          name="product_id"
          value={id == null ? "0" : param.product_id}
          ref={register}
        />
        <div className="card card-custom gutter-b stock-transfer-editor-card">
          <div className="card-header stock-transfer-editor-header d-flex align-items-center justify-content-between flex-wrap">
            <div className="card-title stock-transfer-editor-title">
              <span className="stock-transfer-editor-icon">
                <i className="fa fa-exchange-alt"></i>
              </span>
              <div>
                <h3 className="card-label">{id ? (isView ? "View Stock Transfer" : "Edit Stock Transfer") : "Add Stock Transfer"}</h3>
                <p>{isView ? "View stock transfer details." : "Transfer selected products and quantities to another branch."}</p>
              </div>
            </div>
            {isView && (
              <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: "10px" }}>
                <button
                  type="button"
                  className="btn btn-outline-danger btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToPDF}
                >
                  <i className="fa fa-file-pdf-o mr-2"></i> Download PDF
                </button>
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm font-weight-bold py-2 px-3"
                  onClick={exportToExcel}
                >
                  <i className="fa fa-file-excel-o mr-2"></i> Download Excel
                </button>
              </div>
            )}
          </div>
          <div className="card-body stock-transfer-editor-body">
            <Row className="stock-transfer-editor-grid">
              <Col sm={3}>
                <FormGroup>
                  <Label>Entry No</Label>
                  <input
                    type="text"
                    required
                    readOnly
                    value={param.entry_no}
                    className="form-control h-auto py-2 px-6"
                    name="entry_no"
                    onChange={(e) => setParam({ ...param, entry_no: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

              <Col sm={3}>
                <FormGroup>
                  <Label>Date</Label>
                  <TextField
                    type="date"
                    required
                    disabled={isView}
                    value={param.date}
                    className="form-control"
                    onChange={(e) => {
                      setParam({
                        ...param,
                        date: e.target.value,
                      });
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={3}>
                <FormGroup>
                  <Label>To Branch</Label>
                  <select
                    className="form-control h-auto py-2 px-6"
                    name="to_branch_id"
                    required
                    disabled={isView}
                    value={param.to_branch_id}
                    onChange={(e) => setParam({ ...param, to_branch_id: e.target.value })}
                  >
                    <option value="">-select-</option>
                    {checkObject(branchlist)
                      ? null
                      : branchlist.map((obj, i) => {
                        if (jwl_branch_id != obj.branch_id) {
                          return (
                            <option key={i} value={obj.branch_id}>
                              {obj.company_name}
                            </option>
                          );
                        }

                      })}
                  </select>
                </FormGroup>
              </Col>
              <Col sm={3}>
                <FormGroup>
                  <Label>Remarks</Label>
                  <textarea
                    value={param.remarks}
                    className="form-control h-auto px-6"
                    name="remarks"
                    disabled={isView}
                    onChange={(e) => setParam({ ...param, remarks: e.target.value })}
                    ref={register}
                  />

                </FormGroup>
              </Col>
            </Row>
            {!isView && param.status && param.status.toUpperCase() == "PENDING" ? <Row className="stock-transfer-editor-section">
              <Col sm={5}>
                <div className="stock-transfer-editor-section-title">
                  <h4>Searched Products</h4>
                </div>
              </Col>
              <Col sm={7}>
                <FormGroup className="stock-transfer-editor-search">
                  <input
                    type="text"
                    value={searchProduct}
                    className="form-control h-auto py-2 px-6"
                    name="search"
                    onChange={(e) => setSearchProduct(e.target.value)}
                  />
                  {seachProdutListLoading ? <button type="button" className="btn btn-info stock-transfer-editor-inline-btn">Searching..</button> :

                    <button type="button" className="btn btn-success stock-transfer-editor-inline-btn" onClick={() => { searchProductFun() }}>Search</button>
                  }

                </FormGroup>
              </Col>
              <Col sm={12}>
                <div className="stock-transfer-editor-table-wrap">
                  <Table bordered className="stock-transfer-editor-table">
                    <thead>
                      <tr>
                        <th>Product Code </th>
                        <th>Product</th>
                        <th>Size</th>
                        <th>Color</th>
                        <th>Image</th>
                        <th>Available Qty</th>
                        <th>Qty</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {seachProdutList.length > 0
                        ? seachProdutList.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {obj.product_code}
                                {/* {obj.url_image +""+obj.image_path} */}
                              </td>
                              <td>
                                {obj.product}
                              </td>
                              <td>
                                {obj.size_length}
                              </td>
                              <td>
                                {obj.color}
                              </td>
                              <td>
                                {obj.isImageUrl === true || obj.isImageUrl === "true" ? (
                                  <img src={obj.image_path} width="36px" />
                                ) : (
                                  <img src={obj.url_image + obj.image_path} width="36px" />
                                )}

                              </td>
                              <td>
                                {obj.qty}
                              </td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  min="1"
                                  value={obj.transfer_qty}
                                  onFocus={() => {
                                    if (obj.transfer_qty === 1) {
                                      const temp = [...seachProdutList];
                                      temp[temp.findIndex(x => x.product_id === obj.product_id)]
                                        .transfer_qty = "";
                                      setseachProdutList(temp);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    let val = e.target.value;
                                    if (val === "" || Number(val) < 1) {
                                      val = 1;
                                    }
                                    if (Number(val) > Number(obj.qty)) {
                                      val = obj.qty;
                                    }
                                    const temp = [...seachProdutList];
                                    temp[temp.findIndex(x => x.product_id === obj.product_id)]
                                      .transfer_qty = val;
                                    setseachProdutList(temp);
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    if (val !== "" && Number(val) < 1) {
                                      val = 1;
                                    }
                                    if (val !== "" && Number(val) > Number(obj.qty)) {
                                      val = obj.qty;
                                      showErrorToast("Qty can not be more then available qty.");
                                    }
                                    const temp = [...seachProdutList];
                                    temp[temp.findIndex(x => x.product_id === obj.product_id)]
                                      .transfer_qty = val;

                                    setseachProdutList(temp);
                                  }}
                                />
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className={`btn ${Number(obj.qty) <= 0 ? "btn-secondary" : "btn-success"
                                    } stock-transfer-editor-inline-btn`}
                                  disabled={Number(obj.qty) <= 0}
                                  onClick={() => {
                                    if (obj.transfer_qty == undefined) {
                                      obj.transfer_qty = 1;
                                      AddProductSearch(obj);
                                      showSuccessToast("Qty Added.");
                                    } else if (obj.qty >= obj.transfer_qty) {
                                      showSuccessToast("Qty Added.");
                                      AddProductSearch(obj);
                                    } else {
                                      var temp = [...seachProdutList];
                                      temp[temp.findIndex((x) => x.product_id == obj.product_id)].transfer_qty = 1;
                                      setseachProdutList(temp);
                                      showErrorToast("Qty can not be more then available qty.");
                                    }
                                  }}
                                >
                                  Add
                                </button>
                              </td>
                            </tr>
                          );
                        }) : <tr>
                          <td colSpan="6" className="text-center stock-transfer-editor-empty">
                            No Data
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row> : null}
            <Row className="stock-transfer-editor-section">
              <Col sm={12}>
                <div className="stock-transfer-editor-section-title">
                  <h4>Transfer Products {productsValidation ? <label className="text-danger">*Required</label> : null}</h4>
                </div>
                <div className="stock-transfer-editor-table-wrap">
                  <Table bordered className="stock-transfer-editor-table">
                    <thead>
                      <tr>
                        <th>Product Code</th>
                        <th>Product</th>
                        <th>Size</th>
                        <th>Color</th>
                        <th>Image</th>
                        <th>Available Qty</th>
                        <th>Qty</th>
                        <th>Status</th>
                        {!isView && param.status && param.status.toUpperCase() == "PENDING" ? <th>Action</th> : null}
                      </tr>
                      {!isView && param.status && param.status.toUpperCase() == "PENDING" ? <tr>
                        <th>
                          <Autocomplete
                            id="combo-box-demo"
                            size="small"
                            options={productlist}
                            onChange={(event, value) => {
                              if (value != null)
                                setStockinproductParam({
                                  ...stockinproductParam,
                                  product_code: value.product_code,
                                  product_id: value.product_id,
                                  product: value.product_name,
                                  size_length: value.size_length,
                                  color: value.color,
                                  qty: value.qty,
                                  transfer_qty: 1,
                                  image_path: value.image_path,
                                  url_image: value.url_image,
                                  isImageUrl: value.isImageUrl
                                })
                            }}
                            getOptionLabel={(option) => option.product_code}
                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                          />

                        </th>
                        <th>
                          <input
                            type="text"
                            className="form-control h-auto py-2 px-6"
                            name="product"
                            disabled='false'
                            value={stockinproductParam.product}
                          />
                        </th>
                        {/* <td><img src={stockinproductParam.url_image +""+stockinproductParam.image_path} width="36px" alt="" />   </td>         */}
                        <td>{stockinproductParam.size_length}</td>
                        <td>{stockinproductParam.color}</td>
                        <td>
                          {stockinproductParam.isImageUrl ? (
                            <img src={stockinproductParam.image_path} width="36px" alt="" />
                          ) : (
                            <img src={stockinproductParam.url_image + stockinproductParam.image_path} width="36px" alt="" />
                          )}
                        </td>
                        <th>{stockinproductParam.qty}</th>
                        <th>
                          <input
                            type="number"
                            className="form-control"
                            min="1"
                            value={stockinproductParam.transfer_qty}
                            onFocus={() => {
                              if (stockinproductParam.transfer_qty === 1) {
                                setStockinproductParam({
                                  ...stockinproductParam,
                                  transfer_qty: ""
                                });
                              }
                            }}
                            onBlur={(e) => {
                              let val = e.target.value;
                              if (val === "" || Number(val) < 1) val = 1;
                              if (Number(val) > Number(stockinproductParam.qty)) val = stockinproductParam.qty;
                              setStockinproductParam({
                                ...stockinproductParam,
                                transfer_qty: val
                              });
                            }}
                            onChange={(e) => {
                              let val = e.target.value;
                              if (val !== "" && Number(val) < 1) {
                                val = 1;
                              }
                              if (val !== "" && Number(val) > Number(stockinproductParam.qty)) {
                                val = stockinproductParam.qty;
                                showErrorToast("Qty can not be more then available qty.");
                              }
                              setStockinproductParam({
                                ...stockinproductParam,
                                transfer_qty: val
                              })
                            }}
                          />
                        </th>
                        <th></th>
                        <th>
                          <button type="button" className="btn btn-success stock-transfer-editor-inline-btn"
                            // onClick={() => {                          
                            //   if(stockinproductParam.qty >=  stockinproductParam.transfer_qty)
                            //   {
                            //     AddProduct();
                            //   }
                            //   else{                            
                            //     showErrorToast("Qty is not more then available qty.")
                            //   }

                            //   }}

                            onClick={() => {

                              if (Number(stockinproductParam.qty) <= 0) {
                                showErrorToast("Product is out of stock.");
                                return;
                              }

                              if (stockinproductParam.qty >= stockinproductParam.transfer_qty) {
                                AddProduct();
                              }
                              else {
                                showErrorToast("Qty is not more then available qty.");
                              }

                            }}
                          >
                            Add
                          </button>
                        </th>
                      </tr> : null}
                    </thead>
                    <tbody>
                      {stocktransferproducts.length > 0
                        ? stocktransferproducts.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                ({i + 1}) {obj.product_code}
                              </td>
                              <td>{obj.product}</td>
                              <td>{obj.size_length}</td>
                              <td>{obj.color}</td>
                              <td>
                                {obj.isImageUrl ? (
                                  <img src={obj.image_path} width="36px" alt="" />
                                ) : (
                                  <img src={obj.url_image + obj.image_path} width="36px" alt="" />
                                )}
                              </td>
                              {/* <td><img src={obj.url_image +""+obj.image_path} width="36px" alt="" />   </td>  */}
                              <td>{obj.qty}</td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control h-auto py-2 px-6"
                                  name="qty"
                                  min="1"
                                  disabled={isView}
                                  value={obj.transfer_qty}
                                  onFocus={() => {
                                    if (obj.transfer_qty === 1) {
                                      var temp = [...stocktransferproducts]
                                      temp[temp.findIndex(x => x.product_id == obj.product_id)].transfer_qty = "";
                                      setstocktransferproducts(temp);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    let val = e.target.value;
                                    if (val === "" || Number(val) < 1) val = 1;
                                    if (Number(val) > Number(obj.qty)) val = obj.qty;
                                    var temp = [...stocktransferproducts]
                                    temp[temp.findIndex(x => x.product_id == obj.product_id)].transfer_qty = val;
                                    setstocktransferproducts(temp);
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    if (val !== "" && Number(val) < 1) {
                                      val = 1;
                                    }
                                    if (val !== "" && Number(val) > Number(obj.qty)) {
                                      val = obj.qty;
                                      showErrorToast("Qty can not be more then available qty.");
                                    }
                                    var temp = [...stocktransferproducts]
                                    temp[temp.findIndex(x => x.product_id == obj.product_id)].transfer_qty = val;
                                    setstocktransferproducts(temp);
                                  }
                                  }
                                />
                              </td>
                              <td>

                                {obj.status == 'Accepted' ? <span className="stock-transfer-editor-status accepted">Accepted</span> : obj.status == 'Canceled' ? <span className="stock-transfer-editor-status canceled">Cancel</span> : <span className="stock-transfer-editor-status pending">Pending</span>}
                              </td>
                              {!isView && param.status && param.status.toUpperCase() == "PENDING" ? <td>

                                <button type="button" className="stock-transfer-editor-remove-btn" onClick={() => removeProduct(i)}>
                                  x
                                </button>
                              </td> : null}
                            </tr>
                          );
                        })
                        : <tr>
                          <td colSpan={!isView && param.status && param.status.toUpperCase() == "PENDING" ? "7" : "6"} className="text-center stock-transfer-editor-empty">
                            No Data
                          </td>
                        </tr>}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {successDelete ? <Alert color="danger">{loadDeleteMsg}</Alert> : null}
          </div>
          <div className="card-footer text-right stock-transfer-editor-footer">
            <a href="/branch/stock-transfer" className="btn btn-secondary stock-transfer-editor-cancel-btn">
              {isView ? "Back" : "Cancel"}
            </a>
            {id && (
              loadDelete ? <button type="button" className="btn btn-danger stock-transfer-editor-action-btn">
                Deleting..
              </button> : (!isView && param.status && param.status.toUpperCase() == "PENDING" ?
                <button type="button" onClick={handleDelete} className="btn btn-danger stock-transfer-editor-action-btn">
                  Delete
                </button> : null)
            )}

            {loadInser ?
              <button type="button" className="btn btn-primary stock-transfer-editor-action-btn">
                Saving..
              </button> : (!isView && param.status && param.status.toUpperCase() == "PENDING") ? <button type="submit" className="btn btn-primary stock-transfer-editor-action-btn">
                Save
              </button> : null}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddStocktransfer;
